import React from 'react';
import { Link } from 'react-router-dom';
import HeaderImg from '../../assests/Group 1.png';
import './hero.css';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t, i18n } = useTranslation();
  const en = i18n.language.startsWith('en');
  return (
    <section className="hero-container">
      <div className="intro-text">
        <span className="hero-eyebrow">THAS MULTITECH · STOCKHOLM</span>
        <h1>{t('From Concept to Creation')}</h1>
        <p>{en ? 'Electronics, digital experiences and 3D printing. We help turn your idea into something that works.' : 'Elektronik, digitala upplevelser och 3D-utskrift. Vi hjälper dig att göra din idé till något som fungerar.'}</p>
        <div className="hero-actions">
          <Link className="site-button site-button-light" to="/#contact">{en ? 'Request a quote' : 'Be om en offert'} <span aria-hidden="true">↗</span></Link>
          <Link className="hero-secondary" to="/#services">{en ? 'Explore our services' : 'Utforska våra tjänster'} ↓</Link>
        </div>
        <p className="hero-note">{en ? 'Start with a question, a sketch or an idea.' : 'Börja med en fråga, en skiss eller en idé.'}</p>
      </div>
      <div className="intro-img"><img src={HeaderImg} alt="" width="700" height="700" fetchpriority="high" /></div>
    </section>
  );
}
